import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconClose.module.css';
const SIZE_SMALL = 'small';

const IconClose = props => {
  const { className, rootClassName, size } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(size === SIZE_SMALL
        ? {
            width: 9,
            height: 9,
          }
        : {
            width: 24,
            height: 24,
          })}
    >
      <path
        d="M4.75207 3.69142L3.69141 4.75208L10.9392 11.9999L3.69142 19.2478L4.75208 20.3084L11.9999 13.0606L19.2478 20.3084L20.3084 19.2478L13.0606 11.9999L20.3084 4.75207L19.2478 3.69141L11.9999 10.9393L4.75207 3.69142Z"
        fill="black"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconClose.defaultProps = {
  className: null,
  rootClassName: null,
};

IconClose.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconClose;
